import React from 'react';
import { CatalogContent } from '@/pages/CatalogPage';

export default function FounderCatalog() {
  return (
    <div className="space-y-4">
      <div className="h-panel-thin p-6">
        <div className="h-eyebrow">Founder Preview</div>
        <div className="h-display text-4xl mt-1" style={{ color: 'var(--heritage-plum)' }}>The Catalogue</div>
        <div className="text-sm opacity-80 mt-1" style={{ color: 'var(--heritage-plum)' }}>
          You are seeing the Heritage Original Collection before it opens to the public. Founders receive first access and exclusive colourways.
        </div>
      </div>
      <CatalogContent compact />
    </div>
  );
}
